import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/26lights-logo.png'


const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "center" }
const _hoisted_3 = { class: "login-label" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "errors"
}
const _hoisted_6 = {
  key: 1,
  class: "loading apollo"
}
const _hoisted_7 = { class: "login-modal__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicButton = _resolveComponent("BasicButton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "login-title" }, [
          _createElementVNode("img", {
            class: "logo",
            src: _imports_0,
            alt: "My26"
          })
        ], -1)),
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submitForm()), ["prevent"])),
          class: "login-form"
        }, [
          _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.t("email")), 1),
          _withDirectives(_createElementVNode("input", {
            id: "login-email",
            class: "login-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userEmail) = $event)),
            placeholder: _ctx.t('emailPlaceholder'),
            ref: "inputRef"
          }, null, 8, _hoisted_4), [
            [_vModelText, _ctx.userEmail]
          ]),
          (_ctx.v$.userEmail.$errors.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.userEmail.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: error.$uid,
                    class: "validation-error"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_BasicButton, {
            disabled: _ctx.isDisabled,
            color: "primary",
            class: "login-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("buttons.login")), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.t("loading")), 1))
            : _createCommentVNode("", true)
        ], 32)
      ])
    ]),
    (_ctx.isModalVisible)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onClose: _ctx.closeModal,
          size: "md",
          class: "login-Modal"
        }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.modalHeader), 1)
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.iconName)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    icon: _ctx.iconName,
                    class: "login-modal__icon"
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, _toDisplayString(_ctx.modalBody), 1)
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}